import { useMutation } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import { broadcastPropsUpdated } from '../../../../components/preview-messages';

interface UpdateColorPaletteParams {
  websiteId: string;
  primaryColor: string;
}

function updateColorPalette({ websiteId, primaryColor }: UpdateColorPaletteParams) {
  return axiosPrivate
    .put(`/v3/pharmacist/plus-websites/${websiteId}/themes/color-palettes`, { primaryColor })
    .then((r) => r.data);
}

export function useUpdateColorPalette() {
  return useMutation({
    mutationFn: updateColorPalette,
    onSuccess: () => broadcastPropsUpdated(),
    meta: {
      successMessage: 'Brand palette updated successfully',
      errorMessage: 'Failed to update brand palette',
    },
  });
}
